type ListingHeaderProps = {
  title: string;
  eyebrow?: string;
  description?: string;
  avatarUrl?: string;
};

/**
 * The strip above a category, author or team reveal listing: who or what the
 * list is about, in the reader's words rather than a slug.
 */
export const ListingHeader = ({
  title,
  eyebrow,
  description,
  avatarUrl
}: ListingHeaderProps) => (
  <header
    className="relative mx-auto mb-8 flex max-w-7xl items-center gap-5"
    data-cy="listing-header"
  >
    {avatarUrl && (
      <img
        src={avatarUrl}
        alt=""
        className="h-16 w-16 shrink-0 rounded-full bg-gray-200 object-cover sm:h-20 sm:w-20"
      />
    )}
    <div>
      {eyebrow && (
        <p className="m-0 mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
          {eyebrow}
        </p>
      )}
      <h1 className="m-0 text-2xl font-bold text-gray-900 sm:text-3xl">
        {title}
      </h1>
      {description && (
        <p className="m-0 mt-2 max-w-2xl text-sm text-gray-600 sm:text-base">
          {description}
        </p>
      )}
    </div>
  </header>
);
